import { useEffect } from 'react';

export function useScrollAnimation(): void {
  useEffect(() => {
    const selectors = '.scroll-animate, .scroll-animate-left, .scroll-animate-right';

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    const elements = document.querySelectorAll(selectors);
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);
}
